import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import { motion } from "framer-motion";

import { Header } from "~/src/components/header";
import { Footer } from "~/src/components/footer";
import {
    VarsFontsStyle,
    VarsHeaderStyle,
    VarsThemeStyle,
    VarsGlobalStyle,
    SpacingVarsStyle,
} from "~/src/config/vars";
import {
    ResetStyle,
    GlobalStyle,
    FontsStyle,
    FormStyle,
    ReactPerfectScrollbar,
    SlickStyle,
} from "~/src/styles";
import { ScrollAnimStyle } from "~/src/components/elements/ScrollAnim";

const Layout = ({ children }) => {
    return (
        <>
            <VarsThemeStyle />
            <ResetStyle />
            <GlobalStyle />
            <FontsStyle />
            <FormStyle />
            <ReactPerfectScrollbar />
            <VarsFontsStyle />
            <VarsGlobalStyle />
            <VarsHeaderStyle />
            <SpacingVarsStyle />
            <SlickStyle />
            <ScrollAnimStyle />

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.4, delay: 0.2 }}
            >
                <SLayout>
                    <Header />
                    <SContent>{children}</SContent>
                    <Footer />
                </SLayout>
            </motion.div>
        </>
    );
};

const SLayout = styled.div``;

const SContent = styled.div``;
// const SModalContent = styled.div``;

Layout.propTypes = {
    children: PT.node.isRequired,
};

export default Layout;
